import { render, staticRenderFns } from "./CancelAppointment.vue?vue&type=template&id=ddc25ae6&"
import script from "./CancelAppointment.vue?vue&type=script&lang=js&"
export * from "./CancelAppointment.vue?vue&type=script&lang=js&"
import style0 from "./CancelAppointment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports